import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./NewCase.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getOptionalCasesDetails, downloadCasesFile } from "../GeneralCases/CaseUtils";
import { Box, Button } from "@mui/material";
import caseTypes from "../../../configs/caseTypeConfig";
import { lighten } from 'polished';
import { useTranslation } from "react-i18next";

const NewCases = () => {
  const { t } = useTranslation("newCases");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userRole = useSelector((state: any) => state.general.userRol);
  const lightenAmount = 0.3; // 20% lighter

  let optionalCasesDetails = useSelector(
    (state: any) => state.case.optional_cases_details
  );

  let defaultAccount = useSelector(
    (state: any) => state.account.default_account
  );

  useEffect(() => {
    if (defaultAccount && defaultAccount.id)
      getOptionalCasesDetails(dispatch, defaultAccount.id);
  }, [defaultAccount]);

  const navigateToSubmitCase = (type) => {
    navigate("/layout/cases/rows?category=" + type + "&type=new");
  };

  const downloadNewCasesFile = () => {
    downloadCasesFile(dispatch, defaultAccount.id);
  };

  return (
    <Box sx={{
      p: 2,
      m: 1,
      textAlign: 'center'
    }}>
      {(userRole === 'admin' || userRole === 'analyst') &&
        <Button
          variant="outlined"
          className="blue-btn"
          sx={{
            height: "min-content",
            marginLeft: "15px",
            marginTop: "20px"
          }}
          onClick={downloadNewCasesFile}
        >
          {t("download_new_cases")}
        </Button>
      }
      {optionalCasesDetails.map((item) =>
        caseTypes.hasOwnProperty(item.type) &&
        <Box className="case-item-box" key={item.type}
          onClick={() => navigateToSubmitCase(item.type)}
          // sx={{bgcolor: () => (caseTypes[item.type].color)}}
          sx={{ bgcolor: () => (lighten(lightenAmount, caseTypes[item.type].color)) }}
        >
          <Box className="description-box"> {t(item.type)}</Box>
          <Box sx={{ width: "10%"}}>
            <Box className="cases-count-box" >{item.count}</Box>
          </Box>
          <Box sx={{ width: "40%", textAlign: "right", paddingRight: "10px" }}>
            <span>{item.sum.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}$</span>

          </Box>

        </Box>
      )}
    </Box>
  );
};
export default NewCases;
